import Profile from 'profile/components';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { fetchProfileIfNeeded } from 'profile/ducks/shared';
import { fetchLanguagesIfNeeded } from 'profile/ducks/languages';
import { fetchCategoriesIfNeeded } from 'common/ducks/categories';
import { getPortfolio } from 'profile/ducks/portfolio';


Profile.need = [
  (params) => fetchProfileIfNeeded(params.profileUsername),
  fetchLanguagesIfNeeded,
  fetchCategoriesIfNeeded,
];


export function mapStateToProps(state) {
  return {
    user: state.user,
    ...state.profile.view,
    portfolioState: getPortfolio(state),
  };
}

export function mapDispatchToProps(dispatch) {
  const actions = {
    fetchProfileIfNeeded,
    fetchLanguagesIfNeeded,
    fetchCategoriesIfNeeded,
  };

  return bindActionCreators(actions, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Profile));



// WEBPACK FOOTER //
// ./profile/containers/index.js